/**
 * Step 1: Company Registration
 * Collects basic company information
 */

import React from 'react';
import { Buildings } from '@phosphor-icons/react';
import { TextField, SelectField, ToggleField, TextAreaField, StepSection, CollapsibleSection } from './SharedComponents';

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

const COUNTRIES = [
  'South Africa', 'Namibia', 'Botswana', 'Zimbabwe', 'Mozambique', 
  'United Kingdom', 'United States', 'Mauritius', 'Other'
];

const Step1CompanyRegistration = ({ formData, updateField }) => {
  return (
    <StepSection
      title="Company Registration"
      description="Enter your company's basic registration details"
      icon={Buildings}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TextField
          label="Registered Company Name"
          value={formData.registered_company_name}
          onChange={(v) => updateField('registered_company_name', v)}
          placeholder="e.g., Acme Financial Services (Pty) Ltd"
          required
          testId="company-name-input"
        />
        <TextField
          label="Registration Number"
          value={formData.registration_number}
          onChange={(v) => updateField('registration_number', v)}
          placeholder="e.g., 2020/123456/07"
          helpText="CIPC company registration number"
          testId="registration-number-input"
        />
        <SelectField
          label="Country of Incorporation"
          value={formData.country_of_incorporation}
          onChange={(v) => updateField('country_of_incorporation', v)}
          options={COUNTRIES}
          testId="country-select"
        />
        <SelectField
          label="Financial Year End"
          value={formData.financial_year_end}
          onChange={(v) => updateField('financial_year_end', v)}
          options={MONTHS}
          placeholder="Select month..."
          testId="fye-select"
        />
      </div>
      
      {/* Parent Company Section */}
      <CollapsibleSection title="Parent Company Details (if applicable)" testId="parent-company-section">
        <div className="space-y-4">
          <TextField
            label="Parent Company Registered Name"
            value={formData.parent_company_name}
            onChange={(v) => updateField('parent_company_name', v)}
            placeholder="e.g., Global Holdings Inc"
            testId="parent-company-name-input"
          />
          <TextField
            label="Parent Company Registration Number"
            value={formData.parent_company_registration}
            onChange={(v) => updateField('parent_company_registration', v)}
            placeholder="Registration number"
            testId="parent-company-reg-input"
          />
          
          <ToggleField
            label="Required to comply with parent company regulatory obligations?"
            checked={formData.comply_with_parent_regulations || false}
            onChange={(v) => updateField('comply_with_parent_regulations', v)}
            testId="parent-compliance-toggle"
          />
          
          {formData.comply_with_parent_regulations && (
            <TextAreaField
              label="Rationale for Parent Company Compliance"
              value={formData.parent_compliance_rationale}
              onChange={(v) => updateField('parent_compliance_rationale', v)}
              placeholder="Explain why you need to comply with parent company regulations..."
              rows={3}
              testId="parent-compliance-rationale"
            />
          )}
        </div>
      </CollapsibleSection>
    </StepSection>
  );
};

export default Step1CompanyRegistration;
